import {MatDialogRef} from '@angular/material/dialog';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {ApiError, ApiResponse, HttpStatusCodesEnum} from '@spa/api';

import {DialogActionsEnum} from './enums/dialog-actions.enum';
import {DialogButtonTypesEnum} from './enums/dialog-button-types.enum';

import {DialogConfigInterface} from './interfaces/dialog-config.interface';

import {environment} from '../../../../environments/environment';
import {Helper} from '../../classes/helpers';

@Component({
    selector: 'app-dialog',
    templateUrl: Helper.getPortalTemplate(),
    styleUrls: [Helper.getPortalStyle()],
})
export class DialogComponent<Type, SubscribeHandlerResponseDataType = any> implements OnInit {
    public actionsEnum: typeof DialogActionsEnum;
    public buttonTypesEnum: typeof DialogButtonTypesEnum;

    @Input() public config!: DialogConfigInterface;

    @Output() public actionButtonClicked: EventEmitter<number>;

    constructor(public dialogRef: MatDialogRef<Type>) {
        this.actionButtonClicked = new EventEmitter();
        this.buttonTypesEnum = DialogButtonTypesEnum;
        this.actionsEnum = DialogActionsEnum;
    }

    ngOnInit(): void {
        if (!this.config) {
            this.config = {
                process: {
                    loading: false,
                    finished: false,
                    failed: false,
                    succeedMessage: '',
                    failedMessage: ''
                },
                buttons: [],
                buttonsDisabled: false,
                buttonsHidden: false
            };
        }
    }

    close(): void {
        this.actionButtonClicked.emit(this.actionsEnum.Decline);
    }

    sendActionCode(action: number, disabled = false): void {
        if (!disabled) {
            this.actionButtonClicked.emit(action);
        }
    }

    startLoading(callback: () => void): void {
        this.config.process.loading = true;
        this.config.buttonsDisabled = true;
        this.config.buttonsHidden = true;

        callback();
    }

    dialogSubscribeHandler(
        successCallback: (argument: SubscribeHandlerResponseDataType) => void,
        errorCallback: (argument: ApiError[]) => void,
        response: ApiResponse<ApiError[] | SubscribeHandlerResponseDataType>
    ): void {
        if (response.status !== HttpStatusCodesEnum.Ok) {
            if (!errorCallback) {
                if (!environment.production) {
                    console.error(response.data);
                }
            } else {
                errorCallback(response.data as ApiError[]);
            }

            this.config.process.failed = true;
        } else {
            if (successCallback) {
                successCallback(response.data as SubscribeHandlerResponseDataType);
            }
        }

        this.config.process.loading = false;
        this.config.process.finished = true;
    }
}
